import React, { useEffect, useMemo, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useFormState, useForm } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import { OnChange } from 'react-final-form-listeners';
import _ from 'lodash';

import QCXFinalTextField from '../../../../shared-components/final-text-field/QCXFinalTextField'; // texto


export default function QCXAtributoTextField({
    metadado, 
    isConsult,
    basePath="",
    ncm=false,
    ...restProps
}) {

    const [label, setLabel] = useState("")
    const [name,  setName] = useState("")
    const [obrigatorio, setObrigatorio] = useState(false);
    const [codigo, setCodigo] = useState("");
    const [tamanhoMaximo, setTamanhoMaximo] = useState(null);
    const form = useForm();

    useEffect(() => {
      if (!ncm) {
        setName(`atributosAdicionais.lpcoForm.jsonFormulario.${metadado?.codigo}.valor`)
      } else {
        setName(`atributosAdicionais.lpcoForm.jsonFormulario.ncm.dados.${metadado?.codigo}.valor`)
      }
      
      setLabel(metadado?.nome);
      setObrigatorio(metadado?.validacao?.obrigatorio || false);
    }, [metadado])

    if(!name) {
        return null
    }

    return (
        <Grid item xs={12} sm={6} md={4}>
            <QCXFinalTextField
                id={codigo}
                key={codigo}
                name={name}
                label={label}
                disabled={isConsult}
                maxLength={tamanhoMaximo}
                required={obrigatorio}
                {...restProps}
            />
        </Grid>

    );
}
